export const reduceSet = (array: any[]) => {
    return Array.from(array.reduce((set, e) => set.add(e), new Set()))
}
